/* ==========================================================================
   Google Tag Manager (GTM-54KM8S75) DataLayer Event Helper
   Pushes structured conversion events to window.dataLayer for GA4 (generate_lead)
   ========================================================================== */

import { getLocale } from '../locales/i18n.js';

/**
 * Push `contact_form_success` event to window.dataLayer after verified 2xx API response.
 * Triggers GTM Custom Event `contact_form_success` -> GA4 `generate_lead` tag.
 *
 * @param {Object} options
 * @param {string} options.formLocation - 'contact_page' | 'homepage'
 * @param {string} [options.formId] - DOM id of the form ('sed-contact-page-form' | 'sed-home-contact-form')
 * @param {string} [options.formLanguage] - Active locale code (defaults to getLocale() || 'en')
 * @param {string} [options.leadType] - Product/vertical identifier (defaults to 'sed')
 * @param {number} [options.value] - Numeric lead conversion value (defaults to 1)
 * @param {string} [options.currency] - ISO currency code (defaults to 'EUR')
 */
export function pushContactFormSuccess({
  formLocation,
  formId,
  formLanguage,
  leadType = 'sed',
  value = 1,
  currency = 'EUR'
} = {}) {
  if (typeof window === 'undefined') return null;

  const resolvedLocation = formLocation || 'contact_page';
  const resolvedFormId =
    formId ||
    (resolvedLocation === 'homepage' ? 'sed-home-contact-form' : 'sed-contact-page-form');
  const resolvedLanguage = formLanguage || getLocale() || 'en';
  const numericValue = typeof value === 'number' && Number.isFinite(value) ? value : 1;

  const payload = {
    event: 'contact_form_success',
    form_id: resolvedFormId,
    form_location: resolvedLocation,
    form_language: resolvedLanguage,
    lead_type: leadType,
    value: numericValue,
    currency: currency || 'EUR'
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);

  return payload;
}
